import {saveAs} from "file-saver";
import zip from "./zip";

export const convertGeoJson2Shp = (gj: any, options: any) => {
	zip(gj, options).then(function (blob: any) {
		saveAs(blob, options.file + '.zip');
	});
}
